import { liveSourcesDefault } from '../utils'

interface Env {
  TERRIFIC?: string
  NEXT_TERRIFIC?: string
  MINUTE_LY?: string
  BASE_URL?: string
  NEWSFLASH_QUERY_SOURCE?: string
  DATA_QUERY_SOURCE?: string
  DATA_QUERY_REPLACE_URLS?: '1' | '0'
  DATA_QUERY_USERNAME?: string
  DATA_QUERY_PASSWORD?: string
  PREBUILD_PAGES?: '1' | '0'
  REVALIDATE_IN_SECONDS?: string
  AD_TARGET_ENV?: string
  GOOGLE_TAG_MANAGER: string
  GOOGLE_ANALYTICS: string
  QDATA_REQUEST_TIMEOUT_IN_SECONDS?: string
  DATA_QUERY_TIMEOUT_IN_SECONDS?: string
  KALTURA_PLAYER_ID?: string
  DISABLE_METRICS?: '1' | '0'
  LIVE_IMA?: 'enabled' | 'disabled'
  LIVE_MID_ROLLS?: 'enabled' | 'disabled'
  GEO_PLUGIN_KEY?: string
  GEO_TTL?: number
  ENABLE_PUSH_NOTIFICATION?: 'enabled' | 'disabled'
  ENABLE_FULL_SCREEN?: 'enabled' | 'disabled'
  KALTURA_CLIENT_TAG: string
  LOGIN_PAGE?: string
  BIG_BROTHER_REGISTRATION?: 'on' | 'off'
  SHOULD_TABOOLA_WAIT_FOR_INTERSTITIAL?: 'on' | 'off'
  TABOOLA_PUBLISHER_ID: number
  MAX_PAGINATION_PAGE: number
  NEXT_ALSO_SKIP_SPECIAL_REF: 'true' | 'false'
  ADBLOCK_DETECTION?: 'enabled' | 'disabled'
}

const env = (typeof process !== 'undefined' ? process.env : {}) as Env

export const config = {
  baseUrl: env.BASE_URL ?? '',
  newsFlashQuerySource: env.NEWSFLASH_QUERY_SOURCE ?? '',
  dataQuerySource: env.DATA_QUERY_SOURCE ?? '',
  dataQueryUsername: env.DATA_QUERY_USERNAME,
  dataQueryPassword: env.DATA_QUERY_PASSWORD,
  replaceUrlsFromDataQuery: env.DATA_QUERY_REPLACE_URLS === '1',
  prebuildPages: env.PREBUILD_PAGES === '1',
  revalidateInSeconds: env.REVALIDATE_IN_SECONDS
    ? +env.REVALIDATE_IN_SECONDS
    : 1,
  adTargetEnv: env.AD_TARGET_ENV ?? null,
  googleTagManager: env.GOOGLE_TAG_MANAGER,
  qdataRequestTimeoutInSeconds:
    +(env.QDATA_REQUEST_TIMEOUT_IN_SECONDS || '') || 15,
  // Only the per-asset minute.ly lookup uses this; the qdata page fetch above
  // keeps its own, longer budget.
  dataQueryTimeoutInSeconds: +(env.DATA_QUERY_TIMEOUT_IN_SECONDS || '') || 3,
  googleAnalytics: env.GOOGLE_ANALYTICS || '',
  kalturaPlayerId: env.KALTURA_PLAYER_ID || '',
  disableMetrics: env.DISABLE_METRICS ?? '0',
  live_ima: env.LIVE_IMA || 'enabled',
  live_mid_rolls: env.LIVE_MID_ROLLS || 'enabled',
  geo_plugin_key: env.GEO_PLUGIN_KEY,
  geo_ttl: env.GEO_TTL || 4,
  enable_push_notification: env.ENABLE_PUSH_NOTIFICATION || 'disabled',
  enable_full_screen: env.ENABLE_FULL_SCREEN || 'disabled',
  kalturaClientTag: env.KALTURA_CLIENT_TAG,
  login_page: env.LOGIN_PAGE || '',
  liveSources: liveSourcesDefault,
  bigBrotherRegistration: env.BIG_BROTHER_REGISTRATION || 'on',
  shouldTaboolaWaitForInterstitial:
    env.SHOULD_TABOOLA_WAIT_FOR_INTERSTITIAL || 'off',
  kaltura_partner_id: '5031',
  kaltura_end_point: 'https://5031.frp1.ott.kaltura.com/api_v3/service/',
  kaltura_application_name: 'com.kaltura.reshet.web',
  uiconf_id: '50272542' as string | number,
  searchPageId: null as null | number,
  hpId: null as null | number,
  allProgramsID: null as null | number,
  activePage: '' as string | number,
  configFile: {
    ros_interstitial: 'off',
    bb_ads_time_interval: 8.5,
    interstitial_page_interval: 1,
    player: {
      autoplay: {
        desktop: true,
        mobile: false,
        app: false,
      },
    },
  },
  plugins: {
    terrific:
      env.TERRIFIC === 'enabled' || env.NEXT_TERRIFIC === 'NEXT_TERRIFIC',
    minute_ly: env.MINUTE_LY === 'enabled',
  },
  maxPaginationPage: env.MAX_PAGINATION_PAGE || 24,
  alsoSkipSpecialRef: env.NEXT_ALSO_SKIP_SPECIAL_REF === 'true',
  adblock_detection: env.ADBLOCK_DETECTION || 'enabled',
  // Set at build time by next.config.js `env`. Must stay literal
  // `process.env.X` reads (not via `env` above) so Next inlines them into the
  // client bundle.
  buildHash: process.env.BUILD_HASH || 'unknown',
  buildTime: process.env.BUILD_TIME || '',
}
